import { useRef, useEffect } from 'react'
import throttle from 'lodash.throttle'

let scrollPosition = 0
const useScrollRemeber = (shouldScroll = true) => {
  const elementRef = useRef(null)

  const onScroll = throttle(e => {
    scrollPosition = e.target.scrollTop
  }, 200)

  useEffect(() => {
    const node = elementRef.current
    if (!shouldScroll) scrollPosition = 0

    if (node) {
      node.scrollTop = scrollPosition
      node.addEventListener('scroll', onScroll)
    }
    return () => {
      if (node) {
        node.scrollTop = scrollPosition
        node.removeEventListener('scroll', onScroll)
      }
    }
  }, [elementRef.current])

  return [elementRef, scrollPosition]
}

export default useScrollRemeber
